import Cookies from 'js-cookie';


window.Cookies = Cookies;



// WEBPACK FOOTER //
// ./src/js/cookies.js